var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedFlowerSticker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_173_1409)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0568 34.4322C36.655 34.4297 37.2765 34.3857 37.922 34.2957C39.374 34.0932 40.705 33.7588 41.9209 33.327C41.7975 35.0909 42.176 36.8766 42.9757 38.4765C43.7659 40.0573 44.8861 41.7115 46.3777 43.0832C44.5615 44.6076 43.3853 46.5203 42.6689 48.398C40.6673 47.179 38.0776 46.3516 34.757 46.2337C35.0547 45.9077 35.3313 45.5804 35.5874 45.2553C37.546 42.7693 38.1421 39.4082 37.0165 36.4503C36.7609 35.7788 36.444 35.0995 36.0568 34.4322ZM21.9284 52.2111C15.7257 52.4363 11.9627 48.2478 10.0777 44.4767C9.00882 42.3382 8.69245 39.8679 9.32115 37.5612C10.5574 33.0254 14.3325 27.6353 23.3707 27.7908C24.0423 27.8024 24.6849 27.8424 25.2995 27.9085C25.054 27.5013 24.8308 27.0928 24.629 26.6892C23.5601 24.5507 23.2437 22.0803 23.8724 19.7737C25.1087 15.2379 28.8837 9.84773 37.922 10.0033C46.1357 10.1447 50.0027 14.5502 51.5678 18.6628C51.9975 19.7922 52.1763 20.9803 52.1241 22.156C53.3641 21.8964 54.7412 21.7643 56.2687 21.7906C64.4824 21.9319 68.3495 26.3375 69.9145 30.4501C71.0401 33.408 70.444 36.769 68.4854 39.255C67.6119 40.3637 66.5005 41.4976 65.1277 42.5227C67.587 44.1919 69.0789 46.4713 69.9145 48.6671C71.0401 51.625 70.444 54.986 68.4854 57.472C66.1934 60.3813 62.2631 63.4638 56.2687 64.3C52.6093 64.8104 49.7192 63.8402 47.5014 62.223C47.2343 62.7357 46.9181 63.2265 46.5552 63.6872C44.2631 66.5965 40.3328 69.679 34.3384 70.5152C27.2706 71.501 23.0723 66.9636 21.0455 62.9087C19.9765 60.7701 19.6602 58.2998 20.2889 55.9931C20.6269 54.7527 21.1549 53.4484 21.9284 52.2111Z",
    fill: "#FF7074"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_173_1409)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.3325,
    cy: 42.0158,
    rx: 10.0809,
    ry: 10.4686,
    fill: "#FFF3B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_173_1409",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55 0 0 0 0 0.00229168 0 0 0 0 0.00229168 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_173_1409"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_173_1409",
    x: 31.2516,
    y: 31.5471,
    width: 20.1619,
    height: 20.9373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.808333 0 0 0 0 0.503861 0 0 0 0 0.0471528 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_173_1409"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlowerSticker);
export default __webpack_public_path__ + "static/media/red_flower_sticker.d9559c460d0a0ba69c4b5de9fae95f09.svg";
export { ForwardRef as ReactComponent };